import { render, staticRenderFns } from "./StaffAndPayrollTimeline.vue?vue&type=template&id=5f4e48ae"
import script from "./StaffAndPayrollTimeline.vue?vue&type=script&lang=js"
export * from "./StaffAndPayrollTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports